import Navbar from './components/Navbar/Navbar';
import Content from './components/Content/Content';

function App() {
	return (
		<>
			<Navbar />
			<Content />
		</>
	);
}

export default App;
